import { ID } from "./models"

class APP_URL {
  static INDEX = '/'
  static DASHBOARD = `${process.env.PUBLIC_URL}/dashboard`

  static HOME = `${process.env.PUBLIC_URL}/home`

  static AUTH_LOGIN = `${process.env.PUBLIC_URL}/auth`
  static AUTH_REGISTRATION = `${process.env.PUBLIC_URL}/auth/registration`
  static AUTH_FORGOT_PASSWORD = `${process.env.PUBLIC_URL}/auth/forgot-password`

  static PROFILE_OVERVIEW = `${process.env.PUBLIC_URL}/profile`
  static PROFILE_CHANGEPASSWORD = `${process.env.PUBLIC_URL}/profile/changepassword`
  static PROFILE_NOTIFICATIONS = `${process.env.PUBLIC_URL}/profile/motifications`
  
  static ERROR_404 = `${process.env.PUBLIC_URL}/error/404`
  static ERROR_403 = `${process.env.PUBLIC_URL}/error/403`

  static ORDERS_INDEX = `${process.env.PUBLIC_URL}/orders`
  // static ORDERS_VIEW = (typeId: string, orderDate: Date) => `${process.env.PUBLIC_URL}/orders/view?typeId=${typeId}&orderDate=${orderDate.toString()}`

  static ORDERS_ITEM_LINK = (typeId: string, orderDate: Date, onQualifyDate?: Date, completeDate?: Date) => {
    var link = `${process.env.PUBLIC_URL}/orders/`

    if (onQualifyDate && onQualifyDate !== null) {
      link += `qualify/${typeId}/${orderDate.toString()}/${onQualifyDate.toString()}`
    }
    else {
      link += `view/${typeId}/${orderDate.toString()}`
      if (completeDate) {
        link += `/${completeDate.toString()}`
      }
    }

    return link
  }

  static PAYMENTS_INDEX = `${process.env.PUBLIC_URL}/payments`
  static PAYMENTS_VIEW = `${process.env.PUBLIC_URL}/payments`

  static CUSTOMERS_INDEX = `${process.env.PUBLIC_URL}/org/customers`
  static CUSTOMER_VIEW = (id: ID) => `${process.env.PUBLIC_URL}/org/customers/${id}`
  static STATS_INDEX = `${process.env.PUBLIC_URL}/org/stats`
  static MY_ORGANIZATION = `${process.env.PUBLIC_URL}/org/settings`

  static MAILINGLIST_DRAFT = `${process.env.PUBLIC_URL}/org/mailing`
  static MAILINGLIST_SCHEDULED = `${process.env.PUBLIC_URL}/org/mailing/scheduled`
  static MAILINGLIST_SENDING = `${process.env.PUBLIC_URL}/org/mailing/sending`
  static MAILINGLIST_SENT = `${process.env.PUBLIC_URL}/org/mailing/sent`
  static MAILINGLIST_EDIT = (id: string) => `${process.env.PUBLIC_URL}/org/mailing/compose/${id}`
  static MAILINGLIST_NEW = `${process.env.PUBLIC_URL}/org/mailing/compose`
  

  static HARTIYA_INDEX = `${process.env.PUBLIC_URL}/org/hartiya`

  static ADMIN_USERS_INDEX = `${process.env.PUBLIC_URL}/admin/users`

  static ADMIN_ORGS_INDEX = `${process.env.PUBLIC_URL}/admin/orgs`
  static ADMIN_ORG_VIEW = (id: string) => `${APP_URL.ADMIN_ORGS_INDEX}/${id}`

  static USER_VIEW = (id: string) => `${process.env.PUBLIC_URL}/users/view/${id}`

  
}


export {
  APP_URL,
}